var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "bg-white p-15",
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 16 } },
          _vm._l(_vm.cards, function (card) {
            return _c(
              "el-col",
              {
                key: card.key,
                staticClass: "mb-15",
                attrs: { xs: 12, sm: 8, md: 8 },
              },
              [
                _c(
                  "el-card",
                  {
                    staticClass: "cursor",
                    attrs: { shadow: "hover" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.goBillList(card)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "fs-s3 text-gray" }, [
                      _vm._v(_vm._s(card.title)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fs-a2 mt-10 text-primary" }, [
                      _vm._v(_vm._s(card.value)),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }